<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>
    <div class="lightbox">
      <div>
        <h1>Apply for Hardcopy Invitation</h1>
        <p class="my-3">&nbsp;</p>
        <form
          name="_method"
          enctype="multipart/form-data"
          id="form"
          @submit.prevent="submitInvitePaper"
        >
          <!-- hidden -->
          <input type="hidden" name="RegNo" />
          <!-- hidden end -->

          <p class="my-4">&nbsp;</p>

          <!-- <div class="mr-4">Please click at the box below:</div> -->

          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              id="inlineRadio1"
              value="1"
              v-model="InvitationQty"
            />
            <label class="form-check-label" for="inlineRadio1"
              >Yes, please send me the hardcopy ones</label
            >
          </div>
          <div class="form-check mt-2">
            <input
              class="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              id="inlineRadio2"
              value="0"
              v-model="InvitationQty"
            />
            <label class="form-check-label" for="inlineRadio2">No</label>
          </div>

          <hr />
          <p>
            <button type="submit" class="btnStyle">Send</button>
          </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  data() {
    return {
      UserId: "",
      RegNo: "",
      CSRF_Token: "",
      InvitationQty: "",
      InvitationCompanyName: "",
      lang: "en",
      InvitationSampleImg: "",
      hasAccountId: true,
      MenuInvitation: [],
    };
  },
  methods: {
    closefancybox() {
      parent.$.fancybox.close();
    },

    submitInvitePaper() {
      const vm = this;
      const url = "/apiExhibitors/HardcopyInvitation/";

      const info = {
        RegNo: vm.RegNo,
        InvitationQty: vm.InvitationQty,
        CSRF: vm.CSRF_Token,
      };

      if (vm.InvitationQty) {
        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            alert("Your information has been changed.");
            vm.closefancybox(); //關閉彈跳視窗
            parent.window.location.reload();
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert("System is busy, please try again later.");
            vm.closefancybox();
            parent.window.location.reload();
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 253) {
            alert("The application is closed! ");
            vm.closefancybox();
            parent.window.location.reload();
          }
        });
      } else {
        alert("Please select one of the options.");
      }
    },
  },

  created() {
    const vm = this;

    //取得語系

    let lang = "en";

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    //取得既有資料

    let url = `/apiExhibitors/HardcopyInvitation/${vm.RegNo}?lang=${vm.lang}`;

    axios.get(url).then((response) => {
      if (response.data.Data) {
        vm.InvitationQty = response.data.Data.InvQty;
      }
    });

    //取得參展商總資訊
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`
      )
      .then((response) => {
        vm.InvitationSampleImg = response.data.Data.InvitationSample;
      });

    //判斷是否有AccountID
    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        // console.log(response.data.Data)

        let AccountID = response.data.Data.AccountID;

        if (!AccountID) {
          vm.hasAccountId = false;

          $.getJSON(
            "/apiExhibitors/ExpoContact/" + RegNo + "?lang=" + lang,
            function (data) {
              $('[name="ExpoContact"]').html(data.ExpoContact);
            }
          );
        } else {
          vm.hasAccountId = true;
        }
      });

    //取得邀請選單
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=${vm.lang}`
      )
      .then((response) => {
        // console.log(response.data.Data)

        vm.MenuInvitation = response.data.Data;
      });

    $.getJSON(
      "/apiExhibitors/Exhibition/" + vm.RegNo,
      { lang: lang },
      function (data) {
        //get close day
        //var CloseDay = new Date(data.ExhBegin)
        //CloseDay.setDate(CloseDay.getDate() - 70)
        //改抓API的deadline
        var CurrentDate = new Date();
        var ShowCloseDay = new Date(data.HardcopyInvDeadLine);
        var SystemCloseDay = new Date(data.HardcopyInvDeadLine);

        $('[name="CloseDay"]').text(formatDate(ShowCloseDay));
        function formatDate(date) {
          var d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();
          if (month.length < 2) month = "0" + month;
          if (day.length < 2) day = "0" + day;
          return [year, month, day].join("/");
        }

        SystemCloseDay.setDate(ShowCloseDay.getDate() + 1);

        if (CurrentDate > SystemCloseDay) {
          if (lang == "tw") {
            $(".btnStyle").addClass("btnExpire");
          } else {
            $(".btnStyle").addClass("ebtnExpire");
          }
        }

        //get contact info
        $.getJSON(
          "/apiExhibitors/ExpoContact/" + vm.RegNo + "?lang=" + lang,
          function (data) {
            $('[name="ExpoContact"]').html(data.ExpoContact);
          }
        );
      }
    );
  },
};
</script>

<style lang="scss"></style>
